import { Box, Grid, Typography } from "@mui/material";
import React from "react";
import Icon from "../../components/Elements/Icon/Icon";
import Images from "../../constant/images";
import "./AboutUs.css";
import "../Home/Home.css";
import Card from "../../components/Elements/Card/Card";
import { useTranslation } from "react-i18next";
import { Padding } from "@mui/icons-material";
import ButtonComponent from "../../components/Elements/Button/Button";
import LogoCarousel from "../carogel/carogel";
import { Link } from "react-router-dom";

const AboutUs = () => {
  const { t } = useTranslation();
  const services = [
    {
      id: "01",
      title: "Trust",
      icon: Images.one,
      description: "Ensuring confidence in our processes and decisions.",
    },
    {
      id: "02",
      icon: Images.three,

      title: "Honesty",
      description: "Maintaining transparency in all interactions.",
    },
    {
      id: "03",
      icon: Images.three,

      title: "Confidentiality",
      description: "Prioritizing security of sensitive information.",
    },
  ];
  return (
    <>
      <Box className="aboutas-container">
        <Box
          className="aboutas-container-box"
          // padding={"50px"}
        >
          <Box className="container-icon">
            <Icon
              src={Images.aboutusicon}
              alt=""
            
              style={{ marginRight: "50px" }}
            />
          </Box>
          <Box className="container-text">
            <Typography className="right-employee-tittle">
              {t("aboutUs.mainTitle")}{" "}
            </Typography>
            <Typography className="right-employee-paragraph">
              {t("aboutUs.paragraph1")}
            </Typography>
            <Typography className="right-employee-paragraph">
              {t("aboutUs.paragraph2")}{" "}
            </Typography>
            {/* <ButtonComponent type={'button'} className={"HireButton"} style={{ background: "white", color: "#741374", border: "1px solid #741374", marginTop: "45px" }}
                    > Know More</ButtonComponent>  */}
          </Box>
        </Box>
      </Box>
      
      <Box className="responsive-aboutusicon">
        <Icon src={Images.aboutus2icon} alt={""} className="destop-icon"  style={{
    // width: "100px",
    // height: "100px",
    objectFit: "contain",
    backgroundColor: "red", // light gray as placeholder
  }}            
></Icon>

        <Icon
          src={Images.aboutus2iconresponsive}
          alt={""}
          className="mobile-icon"             

        ></Icon>
      </Box>
      <Box className="aboutus-box-main"></Box>
      <Box className="aboutus-mains">
        <Box className="aboutus-box">
          <Card className="aboutus-card">
            <Box display={"flex"} width={"100%"} gap={"20px"}>
              <Box className="info-card">
                <Icon
                  src={Images.vision}
                  alt={""}
                  style={{ marginTop: "10px" }}
                ></Icon>
              </Box>
              <Typography
                className="aboutus-card-heading"
                mb={1}
                margin={"auto 0px"}
              >
                Our Vision
                {/* {t("aboutUs.introduction.card1.title")} */}
              </Typography>
            </Box>
            <Box>
              <Typography className="aboutus-card-paragraph" mt={2}>
                Our corporate goal is to pursue excellence in our professional
                services as well as serving our valued customers to their
                complete satisfaction and to the best of our ability with
                strength of Team work, Honesty & Sincerity.{" "}
                {/* {t("aboutUs.introduction.card1.paragraph")} */}
              </Typography>
            </Box>
          </Card>
        </Box>
        <Box className="aboutus-box">
          <Card className="aboutus-card">
            <Box display={"flex"} width={"100%"} gap={"20px"}>
              <Box className="info-card">
                <Icon
                  src={Images.mission}
                  alt={""}
                  style={{ marginTop: "10px" }}
                ></Icon>
              </Box>
              <Typography
                className="aboutus-card-heading"
                mb={1}
                margin={"auto 0px"}
              >
                Our Mission
                {/* {t("aboutUs.introduction.card1.title")} */}
              </Typography>
            </Box>
            <Box>
              <Typography className="aboutus-card-paragraph" mt={2}>
                We aim to achieve this by ‘Redefining Recruitment’ through
                incorporating a personalized touch through hands on industry
                related experience which establishes and develops a trusted
                business partnership. We want to create value and guarantee that
                we deliver for the long-term business success of our clients.{" "}
                {/* {t("aboutUs.introduction.card1.paragraph")} */}
              </Typography>
            </Box>
          </Card>
        </Box>
        <Box className="aboutus-box">
          <Card className="aboutus-card">
            <Box display={"flex"} width={"100%"} gap={"20px"}>
              <Box className="info-card">
                <Icon
                  src={Images.global}
                  alt={""}
                  style={{ marginTop: "10px" }}
                ></Icon>
              </Box>
              <Typography
                className="aboutus-card-heading"
                mb={1}
                margin={"auto 0px"}
              >
                Global Reach
                {/* {t("aboutUs.introduction.card1.title")} */}
              </Typography>
            </Box>
            <Box>
              <Typography className="aboutus-card-paragraph" mt={2}>
                Our strategy is to tailor our recruitment and advisory services
                for all industries depending on their business requirements and
                needs. We can offer you a full suite of services to make your
                hiring goals successful.{" "}
                {/* {t("aboutUs.introduction.card1.paragraph")} */}
              </Typography>
            </Box>
          </Card>
        </Box>
      </Box>
      {/* <Box className="lightbox"  ></Box> */}
      <Box className="lightbox">
        <Box
          //  mt={3}
          className="light-boxcontainer"
        >
          <Typography className="Coreheading">Core Values</Typography>
          <Typography className="Coreheading-heading">
            Our Reputation is Grounded in
          </Typography>
        </Box>
        <Box display="flex" flexDirection="column" alignItems="center">
          <Box mt={3} width="100%">
            <Grid
              container
              spacing={3}
              justifyContent="center"
              padding={"0px 70px "}
            >
              {services.map((service, index) => (
                <Grid item xs={12} sm={4} key={index}>
                  <Box display="flex" gap="20px" alignItems="flex-start">
                    <Typography className="numaric-value2">
                      {service.id}
                    </Typography>
                    {/* <Icon src={service.icon} alt={""}></Icon> */}
                    <Card className="last-hero-card2">
                      <Typography
                        className="aboutus-card-heading"
                        lineHeight="none"
                        mb={1}
                        sx={{
                          textAlign: "left !important",
                          lineHeight: "32px !important",
                        }}
                      >
                        {service.title}
                      </Typography>
                      <Typography
                        className="aboutus-card2-heading"
                        sx={{
                          textAlign: "left !important",
                          lineHeight: "25px !important",
                        }}
                      >
                        {service.description}
                      </Typography>
                    </Card>
                  </Box>
                </Grid>
              ))}
            </Grid>
          </Box>
        </Box>
      </Box>

      <Box>
        <Box
          //  mt={3}
          justifyContent="center"
          alignItems="center"
          display={"flex"}
          flexDirection={"column"}
        >
          <Typography className="heading" mt={5}>
            Why Choose Almaaly Recruitment?
          </Typography>
        </Box>
        <Box className="Recruitment-card">
          <Box className="Recruitment-container">
            <Typography className="right-employee-tittle2">
              {/* {t("employer.permanentRecruitment")} */}
              Tailored recruitment solutions
            </Typography>
            <Typography
              className="right-Recruitment-paragraph"
              // mt={2}
              // lineHeight={"20px !important"}
            >
              {/* {t("employer.permanentRecruitmentDescription")} */}
              We offer customized hiring strategies to meet specific business
              needs. Our expert recruiters provides executive search, contingent
              workforce management, and recruitment process outsourcing to
              attract top talent, reduce time-to-hire, and improve candidate
              quality, enhancing overall organizational performance.
            </Typography>
          </Box>
          <Box className="Recruitment-card-icon">
            <Icon src={Images.employes2icon} style={{ width: "100%" }} alt="" />
          </Box>
        </Box>
        <Box className="Recruitment-card-center">
          <Box className="Recruitment-card-icon">
            <Icon src={Images.employes3icon} style={{ width: "100%" }} alt="" />
          </Box>
          <Box className="Recruitment-container">
            <Typography className="right-employee-tittle2">
              {/* {t("employer.permanentRecruitment")} */}
              Manpower services{" "}
            </Typography>
            <Typography
              className="right-Recruitment-paragraph"
              // lineHeight={"20px !important"}
            >
              {/* {t("employer.permanentRecruitmentDescription")} */}
              Our strength is flexible and scalable workforce management. We
              provide temporary, permanent, and contract staffing, as well as
              payroll management and compliance support. Our approach enhances
              business agility, reduces labor costs, and improves productivity,
              ensuring access to skilled talent on demand.
            </Typography>
          </Box>
        </Box>
        <Box className="Recruitment-card">
          <Box className="Recruitment-container">
            <Typography className="right-employee-tittle2">
              {/* {t("employer.permanentRecruitment")} */}
              Access to a global talent pool{" "}
            </Typography>
            <Typography
              className="right-Recruitment-paragraph"
              // lineHeight={"20px !important"}
            >
              {/* {t("employer.permanentRecruitmentDescription")} */}
              We connect businesses with top professionals worldwide. Our
              network spans multiple industries and geographies, providing
              instant access to skilled talent, including hard-to-find
              specialists. We accelerate hiring by reducing recruitment costs,
              and at the same time helpsyou in driving business growth.
            </Typography>
          </Box>
          <Box className="Recruitment-card-icon">
            <Icon src={Images.employes4icon} style={{ width: "100%" }} alt="" />
          </Box>
        </Box>
      </Box>
      <Box className="aboutus-box-icon">
        <Icon src={Images.aboutus4} alt={""}></Icon>
        <Icon
          src={Images.aboutusvideo}
          alt={""}
          className="video-icon"
          
        ></Icon>
      </Box>
      <Box>
        <LogoCarousel></LogoCarousel>
      </Box>
      <Box
        
        className="footer2-container "
      >
        <Typography className="heading" color="white !important">
          Let’s Work Together
        </Typography>
        <Typography className="footer2" color="white !important "  textAlign="center"> 
          At Almaaly Recruitment, we believe in healthy relationships that
          empowers each other for a long time. Whether you're a client seeking
          to fill vacancies or a candidate looking for your next move in your
          career, we’re here to guide you through the journey.{" "}
        </Typography>
        <Box display={"flex"} justifyContent={"center"} gap={4}>
          <Link to="/contact" style={{ textDecoration: "none" }}>
            <ButtonComponent
              type={"button"}
              className={"talentButton"}
              style={{
                color: "#741374",
                background: "white",
                width: "171px !important",
              }}
            >
              {" "}
              Contact Us {/* {t("employer.hireTalentButton")} */}
            </ButtonComponent>
          </Link>
          <Link to="/applicant" style={{ textDecoration: "none" }}>
            <ButtonComponent
              type={"button"}
              className={"talentButton"}
              style={{ color: "#741374", background: "white" }}
            >
              {" "}
              Register Your CV {/* {t("employer.hireTalentButton")} */}
            </ButtonComponent>
          </Link>
        </Box>
      </Box>
    </>
  );
};
export default AboutUs;
